import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=3f760eb1&scoped=true&"
import script from "./ViewCourse.vue?vue&type=script&lang=js&"
export * from "./ViewCourse.vue?vue&type=script&lang=js&"
import style0 from "./ViewCourse.vue?vue&type=style&index=0&id=3f760eb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f760eb1",
  null
  
)

export default component.exports